// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ky-0";
export var discountCodeInput = "_ky-1";